// extracted by mini-css-extract-plugin
export default {"Notifications":"Notifications_Notifications__ab7JD","Head":"Notifications_Head__Ttlsp","Cont":"Notifications_Cont__ii7oS"};